<template>
<div class="container-fluid" > 



<!-- Modal -->
<div class="modal" style="display : block" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header ">
        <h5 class="modal-title" id="staticBackdropLabel">
            <i class="fas fa-chart-pie mr-2"></i>
            GRAFICO VENDITE</h5>
       
      </div>
      <div class="modal-body">

        <div v-if="spinner" class="d-flex justify-content-center">
            <div class="spinner-border spinner-grow text-primary" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
       
        <div v-else>
            <GChart :type="type" :data="chartData" :options="chartOptions" />
        </div>

      </div>
      <div class="modal-footer">
        <button @click="$emit('close')" type="button" class="btn btn-primary" >CHIUDI</button>
        
      </div>
    </div>
  </div>
</div>


</div>
</template>

<script>
import api               from "@/api";
import { mapGetters }    from 'vuex';
import { GChart }        from "vue-google-charts";
import fmt               from '@/components/mixins/fmt'
export default {
    mixins     : [fmt],
    props      : ['params'],
  components: {
    GChart
  },
  data() {
    return {


       type             : 'PieChart',
       chartData        : [],
       chartOptions     : {},

        spinner         : false,
        msg             : {

        title     : '',
        body      : '',
        type      : 0

        },


    }


  },

computed :{
    ...mapGetters(['company']),},

created: function() {
   
   this.getData()
  },
 methods: 
  {
   
    
     async getData() 
     {

      this.spinner = true
      
      this.chartData = []
      const sp =  {'sp' : this.params.sp}
      
      const data  = {
        'companyId'    : this.params.companyId,
        'data1'        : this.params.data1,
        'data2'        : this.params.data2,
        'data3'        : this.params.data3,
        'seasonId'     : this.params.seasonId,
        'year'         : this.params.year,
        'departmentId' : this.params.departmentId,
        'storeId'      : this.params.storeId,
        'supplierId'   : this.params.supplierId,
        'brand'        : this.params.brand
      }
      
      
      const json  = Object.assign(data, sp)      
      this.spinner = true
      
      await api.post(json).then(async res => {
         
          if(res.status==200)
            {
              const chartData = []
              let total = 0
              chartData.push(['Provenienza','Totale'])
                
              const dataChart = res.data.recordsets[0]               
             
              dataChart.forEach(item => {
                let itemData  = [item.mp,item.total_sold]
                total += item.total_sold
                chartData.push(itemData) 
              })  
              
             
              
              
              this.chartData = chartData
              this.chartOptions.title = 'ANALISI VENDITE ' 
              // + this.fmt1(total) 
              this.chartOptions.width = 1000
              this.chartOptions.height = 700

                         

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

           
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          this.spinner = false
        });
      

    },
   
  }

};
</script>
<style scoped>
.modal-header{
    background-color : rgb(193, 193, 126);
    color            : black ;
}

</style>
